// Environment configuration using runtime variables
import { getEnvsVariable } from "../utils/getEnvsVariable.js";

// Get environment variables with runtime priority
const envs = getEnvsVariable();

// Build config from environment variables
const config = {
  // API principal
  apiUrl: envs.VITE_API_URL,
  apiTimeout: parseInt(envs.VITE_API_TIMEOUT) || 10000,

  // Keycloak
  keycloak: {
    realm: envs.VITE_KEYCLOAK_REALM,
    url: envs.VITE_KEYCLOAK_URL,
    clientId: envs.VITE_KEYCLOAK_CLIENT_ID,
  },

  // Rutas de entidades (CRUD)
  entities: {
    inspector: envs.VITE_INSPECTOR,
    inspectorAll: envs.VITE_INSPECTOR_ALL,
    inspection: envs.VITE_INSPECTION,
    emv: envs.VITE_EMV,
    supervisor: envs.VITE_SUPERVISOR,
    dniMaskType: envs.VITE_DNI_MASK_TYPE || "/dni-mask-type",
  },

  // Dropdowns (catálogos)
  dropdowns: {
    genders: envs.VITE_GENDERS,
    lines: envs.VITE_LINES,
    companies: envs.VITE_COMPANIES,
    provinces: envs.VITE_PROVINCES,
    municipalities: envs.VITE_MUNICIPALITIES,
    jurisdictions: envs.VITE_JURISDICTIONS,
  },

  // Endpoints especiales
  endpoints: {
    inspectorChangeStatus: envs.VITE_INSPECTOR_CHANGE_STATUS,
    inspectionExportCsv: envs.VITE_INSPECTION_EXPORT_CSV,
    reportDateAndDni: envs.VITE_REPORT_DATEANDDNI,
    inspectionMapPoints: envs.VITE_INSPECTION_MAP_POINTS,
    inspectionDetailV2: envs.VITE_INSPECTION_DETAIL_V2,
  },

  // APIs externas
  external: {
    emvGenerateContext: envs.VITE_API_EMV_URL_GENERATE_CONTEXT,
    emvProcessTransaction: envs.VITE_API_EMV_URL_PROCESS_TRANSACTION,
    emvSgpId: envs.VITE_API_EMV_URL_SGP_ID,
    emvCacheCompanyId: envs.VITE_API_EMV_URL_CACHE_COMPANY_ID,
    userUtilsSupervisor: envs.VITE_API_USER_UTILS_SUPERVISOR,
    userApiEmail: envs.VITE_API_USER_API_EMAIL,
    controlSube: envs.VITE_PATH_CONTROLSUBE,
  },

  // Feature flags por ambiente
  features: {
    mapDateRangeEnabled: envs.VITE_MAP_DATE_RANGE_ENABLED === "true",
    // Líneas de recorrido del mapa (ver useMap.js). Por default (false) solo
    // se muestran para búsqueda de un inspector puntual (DNI). En "true"
    // también se muestran para búsquedas amplias (todos los inspectores) —
    // pensado para poder seguir probando ese caso por ambiente sin afectar
    // el comportamiento restringido de los demás. mapRoutesMaxPoints es el
    // techo de puntos que aplica siempre, en ambos casos.
    mapRoutesEnabled: envs.VITE_MAP_ROUTES_ENABLED === "true",
    mapRoutesMaxPoints: parseInt(envs.VITE_MAP_ROUTES_MAX_POINTS) || 6000,
  },

  // Paths internos
  paths: {
    health: envs.VITE_PATH_HEALTH,
    emv: envs.VITE_PATH_EMV,
    supervisor: envs.VITE_PATH_SUPERVISOR,
    inspector: envs.VITE_PATH_INSPECTOR,
    inspection: envs.VITE_PATH_INSPECTION,
    base: envs.VITE_BASE_PATH,
  },
};

export default config;
